var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCobotPulseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50mm",
    height: "50mm",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75.09a13.885 13.885 0 0013.345 9.956A13.885 13.885 0 0038.373.09z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76 5.432L.657 10.928l7.238 37.098 3.667-2.117-1.92-30.628 4.732-2.556c-2.76-1.82-5.038-4.369-6.614-7.293zm34.62.123c-.306.569-.64 1.123-1.004 1.657-1.459 2.275-3.43 4.142-5.695 5.553l4.657 2.516-1.92 30.628 3.667 2.117 7.238-37.098z",
    stroke: "#000",
    strokeWidth: 0.265
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.64 39.944l3.351-5.805 3.37 5.835 5.617-22.304m12.338 22.274l-3.352-5.805-3.369 5.835-5.617-22.304",
    className: "cobotPulseIcon_svg__UnoptimicedTransforms",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.765,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgCobotPulseIcon;